import { Grid } from '@material-ui/core';
import React from 'react';
import EmeraldModal from 'src/common/components/emerald-modal/emerald-modal';
import { styles } from './keypad-modal-styles';
import ModalTitle from 'src/common/components/modal-title/modal-title';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { DialogIcon } from '../interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';

export interface IKeypadModal {
  onClose?: any;
  title?: string;
  iconType?: EmeraldDialogTypes;
  buttonComponent?: JSX.Element;
  contentArea?: JSX.Element;
  keypad?: JSX.Element;
  bigSize?: boolean;
  modalHeight?: number;
  modalWidth?: number;
}

export const KeypadModal: React.FC<IKeypadModal> = (props: IKeypadModal): JSX.Element => {
  const defaultWidth = 58.56;
  const defaultHeight = 77;
  const classes = styles({
    width: props.modalWidth ?? defaultWidth,
    height: props.modalHeight ?? defaultHeight,
  });
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();
  const isBigSize = props.bigSize || false;
  return (
    <EmeraldModal open={true} data-testid='keypad-modal'>
      <Grid container className={classes.main}>
        <Grid
          item
          container
          direction='row'
          data-testid='keypad-modal-title'
          className={classes.innerTitle}
        >
          <Grid container>
            <ModalTitle title={props.title || ''} description='' className={classes.contentTitle} />
            <Grid container className={classes.icon}>
              <Grid item className={classes.adjustIcon}>
                {props.iconType && <DialogIcon type={props.iconType} />}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          className={
            isBigSize
              ? isLeftHanded
                ? classes.bigModalContentInverse
                : classes.bigModalContent
              : isLeftHanded
              ? classes.modalContentInverse
              : classes.modalContent
          }
          justifyContent='space-between'
        >
          <Grid item container className={isBigSize ? classes.bigInner : classes.inner}>
            {props.contentArea}
            <Grid
              item
              className={
                isLeftHanded ? classes.cancelButtonContainerInverse : classes.cancelButtonContainer
              }
            >
              {props.buttonComponent}
            </Grid>
          </Grid>
          <Grid
            data-testid='keypad-modal-container'
            container
            justifyContent='space-between'
            className={
              isBigSize
                ? isLeftHanded
                  ? classes.bigInnerKeypadInverse
                  : classes.bigInnerKeypad
                : isLeftHanded
                ? classes.innerKeypadInverse
                : classes.innerKeypad
            }
          >
            {props.keypad}
          </Grid>
        </Grid>
      </Grid>
    </EmeraldModal>
  );
};
